import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[zcCell]',
})
export class TableCellDirective {
  constructor(public template: TemplateRef<any>) {}
}
